module["exports"] = [
  "Постач",
  "Торг",
  "Пром",
  "Трейд",
  "Збут"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/company/suffix.js
// module id = 1306
// module chunks = 0